import React, { useState, useRef, useEffect } from "react";
import logo from '../Img/ProMed_Logo.png';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LoginForm = () => {
    const navigate = useNavigate();
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const firstFieldRef = useRef(null);

    useEffect(() => {
        if (firstFieldRef.current) firstFieldRef.current.focus();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Valid email is required";
        }
        if (!formData.password || formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async () => {
        if (validate()) {
            setIsLoggingIn(true); // Start spinner
            try {
                const response = await fetch("https://backend.impactjournal.co.in/register/login", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(formData)
                });

                const result = await response.json();

                if (response.ok) {
                    localStorage.setItem("isLoggedIn", JSON.stringify(result.user));
                    toast.success("Login successful!");
                    navigate("/");
                } else {
                    toast.error(result.message);
                }
            } catch (err) {
                console.error("Login failed:", err);
                toast.error("Something went wrong.");
            } finally {
                setIsLoggingIn(false); // Stop spinner
            }
        }
    };



    const renderError = (field) =>
        errors[field] && <div className="form-register-error-impact">{errors[field]}</div>;



    return (
        <div className="register-main-pm">
            <div className="register-section-pm">
                <div className="register-container-left-pm">
                    <img src={logo} alt="logo" />
                    <h2>WELCOME BACK TO INTERNATIONAL MULTIDISCIPLINARY PHARMACEUTICAL AND CLINICAL TRENDS</h2>
                    <p>
                        Login to manage your submissions, review editorial updates, explore the latest publications,
                        and stay engaged with the forefront of pharmaceutical and medical research.
                    </p>
                </div>

                <div className="form-register-wrapper-impact">
                    <h2>Login into your account</h2>
                    <div className="form-register-step-impact">
                        <div className="form-register-input-group-impact">
                            <input
                                ref={firstFieldRef}
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-register-input-impact"
                            />
                            {renderError("email")}
                        </div>

                        <div className="form-register-input-group-impact">
                            <div className="form-register-password-wrapper-impact">
                                <input
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="form-register-input-impact"
                                />
                                <i
                                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} form-register-eye-icon-impact`}
                                    onClick={() => setShowPassword(!showPassword)}
                                />
                            </div>
                            {renderError("password")}
                        </div>

                        <div className="form-register-navigation-impact">
                            <button
                                onClick={handleLogin}
                                className="form-register-btn-impact form-register-btn-submit-impact"
                                disabled={isLoggingIn}
                            >
                                {isLoggingIn ? <span className="spinner" /> : "Login"}
                            </button>
                        </div>

                        <div className="register-form-footer">
                            Don't have account?{" "}
                            <span onClick={() => navigate("/register-impact")} className="login-link-pm">
                                Register now
                            </span>
                        </div>
                        <div className="register-form-footer">
                            Having Trouble?{" "}
                            <span onClick={() => navigate("/reset-impact")} className="login-link-pm">
                                Reset Now
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
